import { applyMiddleware, combineReducers, compose, createStore } from 'redux';
import thunk from 'redux-thunk';
import {logger} from 'redux-logger'
import * as tagData from '../Reducers/tagDataReducer'
import * as filterData from '../Reducers/searchBarReducer'
const configureStore = () =>{
    const reducers = {
        tagData: tagData.reducer
        ,filterData: filterData.reducer
    };
    
    const isDevelopment = process.env.NODE_ENV === 'development';

    const middleware = (isDevelopment)? [
        thunk, // allows to use function inside the redux action
        logger // log the messsages on each action executed
    ]  :  [thunk]
    const enhancers = [];
/*  window.devToolsExtension IS DEPRECATED    
    if (isDevelopment && typeof window !== 'undefined' && window.devToolsExtension)
        enhancers.push(window.devToolsExtension()); */
    if (isDevelopment && typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__)
        enhancers.push(window.__REDUX_DEVTOOLS_EXTENSION__());
    const rootReducer = combineReducers({
        ...reducers
    });

    const store = createStore(
        rootReducer,
        compose(
            applyMiddleware(...middleware),
            ...enhancers
        )
    );

    return store
    
}

export default configureStore;